import React, { useCallback, useEffect, useMemo, useState } from 'react';
import TableTitle from '../components/TableTitle';
import { useReportsStore } from '../features/reports/useReportsStore';
import { EventBusy, Schedule, SignalCellularAltOutlined, InsertDriveFile, Download } from '@mui/icons-material';
import BtnFilled from '../components/BtnFilled';
import ReportErrors from '../features/reports/ReportErrors';
import { useThrottle } from '../hooks';
import SearchBar from '../components/SearchBar/SearchBar';

const INITIAL_VALUES = { from: null, to: null, object_id: [], format: null };

const Reports = () => {
  const { fetchObjects, objects, formats, handleCreateReport } = useReportsStore();
  const [searchValue, setSearchValue] = useState(INITIAL_VALUES);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    fetchObjects();
  }, []);

  const onCreateReport = useThrottle(async () => {
    const newErrors = [];
    if (!searchValue.object_id || searchValue.object_id.length === 0) {
      newErrors.push('Выберите хотя бы один объект');
    }

    if (!searchValue?.format) {
      newErrors.push('Укажите формат');
    }

    setErrors(newErrors);

    if (newErrors.length > 0) {
      return;
    }

    await handleCreateReport(searchValue);
  }, 1000);

  const handleSearch = useCallback((value, name) => {
    setSearchValue((prev) => ({ ...prev, [name]: value }));
  }, []);

  const inputs = useMemo(
    () => [
      {
        label: 'Выбрать объекты',
        options: objects,
        selectedOptions: searchValue.object_id,
        type: 'filter',
        setSelectedOptions: (value) => handleSearch(value, 'object_id'),
        prefix: <SignalCellularAltOutlined fontSize={'small'} className={'text-gray-500'} />,
      },
      {
        placeholderText: 'Дата начала',
        type: 'date',
        selected: searchValue.from,
        onChange: (value) => handleSearch(value, 'from'),
        prefix: <Schedule fontSize={'small'} className="text-gray-500 mr-2" />,
      },
      {
        placeholderText: 'Дата окончания',
        type: 'date',
        selected: searchValue.to,
        onChange: (value) => handleSearch(value, 'to'),
        prefix: <EventBusy fontSize={'small'} className="text-gray-500 mr-2" />,
      },
      {
        placeholderText: 'Формат',
        type: 'selector',
        options: formats,
        selectedOptions: searchValue.format,
        placeholder: 'Выберите формат',
        onChange: (value) => handleSearch(value, 'format'),
        prefix: <InsertDriveFile fontSize={'small'} className="text-gray-500 mr-2" />,
      },
    ],
    [formats, handleSearch, objects, searchValue.format, searchValue.from, searchValue.object_id, searchValue.to]
  );

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <TableTitle title={'Отчеты'} />
          <BtnFilled
            btnCb={onCreateReport}
            className={'rounded-lg w-fit'}
            title={
              <div className={'flex items-center gap-2'}>
                <Download className="w-5 h-5" />
                Скачать отчёт
              </div>
            }
          />
        </div>
        <SearchBar inputs={inputs} />
        {errors?.length > 0 && <ReportErrors errors={errors} />}
      </div>
    </div>
  );
};
export default Reports;
